import React, { useEffect, useState } from "react";
import { Accordion, Button, Spinner } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLogout } from "../../Feature/Login/LoginSlice";
import {
  setActiveKey,
  setActiveMenu,
  setNewActiveKey,
} from "../../Feature/Sidebar/ActiveKeySlice";
import { setLabelDate, setLabelMonth } from "../../Feature/Graph/label";
import PCMC from "../../Assets/PCMC-LOGO.png";

const Sidebar = () => {
  const userState = useSelector((state) => state.loginData.userData);
  const activeKeyRedux = useSelector(
    (state) => state.activeData.activeNumberKey
  );

  const [parentAccKey, setParentAcckey] = useState(null);

  const activeMenu = useSelector((state) => state.activeData?.activeMenu);

  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  const handleLogout = () => {
    setLoader(true);
    dispatch(setLogout(null));
    dispatch(setActiveKey(0));
    dispatch(setLabelDate(""));
    dispatch(setLabelMonth(""));
    navigate("/");
    setLoader(false);
  };

  const handleAccordionChange = (activeKey, subActiveKey, tabName) => {
    dispatch(
      setActiveKey({
        activeKey: activeKey,
        subActiveKey: subActiveKey,
        activeTab: tabName,
        // financialYear: financialYear
      })
    );
  };

  const handleMenuChange = (activeKey, tabName, event) => {
    // setParentAcckey((prev) => (prev === tabName ? null : tabName));
    dispatch(
      setActiveMenu({
        activeKey: activeKey,
        activeTab: tabName,
      })
    );
    if (activeKey === 0) {
      event.stopPropagation();
    }
  };
  //  useEffect(() => {
  //    const fetchCurrentFY=async()=>{
  //     try {
  //       await fetch(process.env.REACT_APP_BASE_URL+ '/financialyear/getCurrentFY ').then((res)=>res.json()).then((data)=>{
  //         console.log("data",data)
  //       })
  //     } catch (error) {
  //       console.log("error fetching current financial year")
  //     }
  //    }

  //   fetchCurrentFY()
  //  }, [])

  // useEffect(() => {
  //    handleMenuChange(0, "2023-2024", event);


  // }, [])





  return (
    <>
      <div className="sidenav-lg d-flex justify-content-between flex-column">
        <div>
          <div className="logoBg mb-4">
            <img src={PCMC} alt="PCMC Survey" width={70} />
          </div>

          <div className="menus">
            {userState?.usertype_keyname[0] === "admin" ||
              userState?.usertype_keyname[0] === "internalDev" ? (
              <>
                <Accordion flush>
                  {/* 2023-2024 */}
                  <Accordion.Item defaultActiveKey={activeMenu?.activeKey}>
                    <Accordion.Item eventKey="2023-2024"
                      onClick={(event) => {
                        handleMenuChange(0, "2023-2024", event);
                      }}
                    >
                      <Accordion.Header className="newMenu">
                        2023-2024{" "}
                      </Accordion.Header>
                      <Accordion.Body style={{ padding: 0 }}>
                        <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>
                          <Accordion.Item
                            eventKey="0"
                            onClick={() => {
                              handleAccordionChange(0, 0, "Home");
                              navigate("/dashboard");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 0 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 0 ? (
                                <Icon.HouseDoorFill className="me-2" />
                              ) : (
                                <Icon.HouseDoor className="me-2 icon" />
                              )}
                              Home
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="1"
                            onClick={() => {
                              handleAccordionChange(1, 1, "Bill Distribution");
                              navigate("/dashboard/bill-distribution");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 1 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 1 ? (
                                <Icon.ReceiptCutoff className="me-2" />
                              ) : (
                                <Icon.ReceiptCutoff className="me-2 icon" />
                              )}
                              Bill Distribution
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="2"
                            onClick={() => {
                              handleAccordionChange(2, 2, "Manage Roles");
                              navigate("/dashboard/manage-roles");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 2 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 2 ? (
                                <Icon.PersonFillGear className="me-2" />
                              ) : (
                                <Icon.PersonGear className="me-2 icon" />
                              )}
                              Manage Users
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="3"
                            onClick={() => {
                              handleAccordionChange(3, 3, "Mahila Wise Bill Watap Report");
                              navigate("/dashboard/contractors");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 3 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 3 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Mahila Wise Bill Watap Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="4"
                            onClick={() => {
                              handleAccordionChange(4, 4, "Distribution");
                              navigate("/dashboard/distribution");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 4 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 4 ? (
                                <Icon.BarChartFill className="me-2" />
                              ) : (
                                <Icon.BarChart className="me-2 icon" />
                              )}
                              Distribution Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="5"
                            onClick={() => {
                              handleAccordionChange(5, 5, "Zone Wise Bill Analysis");
                              navigate("/dashboard/zonewise-bill-analysis");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 5 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 5 ? (
                                <Icon.ReceiptCutoff className="me-2" />
                              ) : (
                                <Icon.Receipt className="me-2 icon" />
                              )}
                              Zone Wise Bill Analysis
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={6}
                            className={
                              activeKeyRedux.activeKey === 6
                                ? "activeMenu dropDown"
                                : "dropDown"
                            }
                          >
                            <Accordion.Header onClick={() => {
                              handleAccordionChange(6, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab);
                            }}>
                              {activeKeyRedux?.activeKey === 6 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Manage Telecalling
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/call-summary");
                                  handleAccordionChange(6, 6.1, "Call Summary");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 6.1
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 6.1 ? (
                                  <Icon.ChatTextFill className="me-2" />
                                ) : (
                                  <Icon.ChatText className="me-2 icon" />
                                )}{" "}
                                Calling Summary
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/call-logs");
                                  handleAccordionChange(6, 6.2, "Call Logs");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 6.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 6.2 ? (
                                  <Icon.TelephoneForwardFill className="me-2" />
                                ) : (
                                  <Icon.TelephoneForward className="me-2 icon" />
                                )}{" "}
                                Call Logs
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/dialed-call-logs");
                                  handleAccordionChange(6, 6.3, "Dialed Call Logs");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 6.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 6.3 ? (
                                  <Icon.TelephoneForwardFill className="me-2" />
                                ) : (
                                  <Icon.TelephoneForward className="me-2 icon" />
                                )}
                                Dialed Call Logs
                              </Button>
                              <Button
                                onClick={() => {
                                  handleAccordionChange(
                                    6,
                                    6.5,
                                    "Total Call Summary"
                                  );
                                  navigate("/dashboard/total-calling");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 6.5
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 6.5 ? (
                                  <Icon.TelephonePlusFill className="me-2" />
                                ) : (
                                  <Icon.TelephonePlus className="me-2 icon" />
                                )}{" "}
                                Total Call Summary
                              </Button>
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="7"
                            className={
                              activeKeyRedux.activeKey === 7
                                ? "activeMenu dropDown"
                                : "dropDown"
                            }
                          >
                            <Accordion.Header
                              onClick={() => {
                                handleAccordionChange(
                                  7,
                                  activeKeyRedux.subActiveKey,
                                  activeKeyRedux.activeTab
                                );
                              }}
                            >
                              {activeKeyRedux?.activeKey === 7 ? (
                                <Icon.Coin className="me-2" />
                              ) : (
                                <Icon.Coin className="me-2 icon" />
                              )}
                              Japti Details
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/japti-notice");
                                  handleAccordionChange(7, 7.1, "Japti Notice");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 7.1
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 7.1 ? (
                                  <Icon.CardHeading className="me-2" />
                                ) : (
                                  <Icon.CardHeading className="me-2 icon" />
                                )}{" "}
                                Japti Notice
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/japti-karvai");
                                  handleAccordionChange(7, 7.2, "Japti Karvai");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 7.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 7.2 ? (
                                  <Icon.Coin className="me-2" />
                                ) : (
                                  <Icon.Coin className="me-2 icon" />
                                )}{" "}
                                Japti Karvai
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/japti-mukti");
                                  handleAccordionChange(7, 7.3, "Japti Mukti");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 7.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 7.3 ? (
                                  <Icon.Coin className="me-2" />
                                ) : (
                                  <Icon.Coin className="me-2 icon" />
                                )}{" "}
                                Japti Mukti
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/japti-karvai-zone-report");
                                  handleAccordionChange(
                                    7,
                                    7.4,
                                    "Japti Karvai Zone Report"
                                  );
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 7.4
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 7.4 ? (
                                  <Icon.Coin className="me-2" />
                                ) : (
                                  <Icon.Coin className="me-2 icon" />
                                )}
                                Karvai Zone Report
                              </Button>
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={80}
                            onClick={() => {
                              handleAccordionChange(80, 80, "Update Mobile");
                              navigate("/dashboard/update-mobile");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 80 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 80 ? (
                                <Icon.TelephoneFill className="me-2" />
                              ) : (
                                <Icon.Telephone className="me-2 icon" />
                              )}
                              Update Mobile
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={8}
                            onClick={() => {
                              handleAccordionChange(8, 8, "SMS Sent Report");
                              navigate("/dashboard/sms-sent-report");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 8 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 8 ? (
                                <Icon.EnvelopeAtFill className="me-2" />
                              ) : (
                                <Icon.EnvelopeAt className="me-2 icon" />
                              )}
                              SMS Sent Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={9}
                            onClick={() => {
                              handleAccordionChange(9, 9, "SMS Details");
                              navigate("/dashboard/sms-details");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 9 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 9 ? (
                                <Icon.EnvelopeAtFill className="me-2" />
                              ) : (
                                <Icon.EnvelopeAt className="me-2 icon" />
                              )}
                              SMS Details
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={10}
                            onClick={() => {
                              handleAccordionChange(10, 10, "Analytics");
                              navigate("/dashboard/analytics");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 10 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 10 ? (
                                <Icon.BarChartFill className="me-2" />
                              ) : (
                                <Icon.BarChart className="me-2 icon" />
                              )}
                              Analytics
                            </Accordion.Header>
                          </Accordion.Item>

                          {userState?.usertype_keyname[0] === "internalDev" && (
                            <Accordion.Item
                              eventKey="7"
                              onClick={() => {
                                handleAccordionChange(
                                  7,
                                  7.3,
                                  "Internal Developer"
                                );
                                navigate("/dashboard/internal-dev");
                              }}
                              className={
                                activeKeyRedux.activeKey === 7 ? "activeMenu" : ""
                              }
                            >
                              <Accordion.Header>
                                {activeKeyRedux.activeKey === 7 ? (
                                  <Icon.DatabaseFillLock className="me-2" />
                                ) : (
                                  <Icon.DatabaseLock className="me-2 icon" />
                                )}
                                Internal Dev
                              </Accordion.Header>
                            </Accordion.Item>
                          )}
                        </Accordion>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion.Item>

                  {/* 2024-2025 */}
                  <Accordion.Item>
                    <Accordion.Item eventKey="2024-2025"
                      onClick={(event) => {
                        handleMenuChange(1, "2024-2025", event);
                      }}
                    >
                      <Accordion.Header className="newMenu">
                        2024-2025
                      </Accordion.Header>

                      <Accordion.Body style={{ padding: 0 }}>
                        <Accordion
                          flush
                          defaultActiveKey={activeKeyRedux?.activeKey}
                        >
                          {/* New Dashboard Sidebar from here */}
                          <Accordion.Item
                            eventKey={11}
                            onClick={() => {
                              handleAccordionChange(11, 11, "Bill Distribution");
                              navigate("/dashboard/new-home");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 11 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 11 ? (
                                <Icon.HouseDoorFill className="me-2" />
                              ) : (
                                <Icon.HouseDoor className="me-2 icon" />
                              )}
                              Bill Distribution
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="12"
                            onClick={() => {
                              handleAccordionChange(12, 12, "Manage Users");
                              navigate("/dashboard/manage-roles");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 12 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 12 ? (
                                <Icon.PersonFillGear className="me-2" />
                              ) : (
                                <Icon.PersonGear className="me-2 icon" />
                              )}
                              Manage Users
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="13"
                            onClick={() => {
                              handleAccordionChange(13, 13, "Property Visit Report");
                              navigate("/dashboard/new-visit-reports");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 13 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 13 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Property Visit Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="14"
                            onClick={() => {
                              handleAccordionChange(
                                14,
                                14,
                                "Mahila Wise Bill Watap Report"
                              );
                              navigate("/dashboard/new-contractors");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 14 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 14 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Mahila Wise Bill Watap Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="15"
                            onClick={() => {
                              handleAccordionChange(
                                15,
                                15,
                                "Zone Wise Bill Analysis"
                              );
                              navigate("/dashboard/new-bill-analysis");
                            }}
                            className={activeKeyRedux?.activeKey === 15 ? "activeMenu" : ""}
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 15 ? (
                                <Icon.Receipt className="me-2" />
                              ) : (
                                <Icon.Receipt className="me-2 icon" />
                              )}
                              Zone Wise Bill Analysis
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="16"
                            onClick={() => {
                              handleAccordionChange(
                                16,
                                16,
                                "Gatwise Bill Analysis"
                              );
                              navigate("/dashboard/gatwise-bill-analysis");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 16 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 16 ? (
                                <Icon.Receipt className="me-2" />
                              ) : (
                                <Icon.Receipt className="me-2 icon" />
                              )}
                              Gatwise Bill Analysis
                            </Accordion.Header>
                          </Accordion.Item>

                          {/* <Accordion.Item
                          eventKey="16"
                          onClick={() => {
                            handleAccordionChange(16, 16, "Japti Notice");
                            navigate("/dashboard/new-japti-notice");
                          }}
                          className={
                            activeKeyRedux?.activeKey === 16 ? "activeMenu" : ""
                          }
                        >
                          <Accordion.Header>
                            {activeKeyRedux?.activeKey === 16 ? (
                              <Icon.CardHeading className="me-2" />
                            ) : (
                              <Icon.CardHeading className="me-2 icon" />
                            )}
                            Japti Notice
                          </Accordion.Header>
                        </Accordion.Item> */}

                          {/* Telecalling */}
                          <Accordion.Item
                            eventKey={17}
                            className={
                              activeKeyRedux.activeKey === 17
                                ? "activeMenu dropDown"
                                : "dropDown"
                            }
                          >
                            <Accordion.Header
                              onClick={() => {
                                handleAccordionChange(
                                  17,
                                  activeKeyRedux.subActiveKey,
                                  activeKeyRedux.activeTab,
                                );
                              }}
                            >
                              {activeKeyRedux?.activeKey === 17 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Manage Telecalling
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/call-summary");
                                  handleAccordionChange(17, 17.1, "Call Summary");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 17.1
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 17.1 ? (
                                  <Icon.ChatTextFill className="me-2" />
                                ) : (
                                  <Icon.ChatText className="me-2 icon" />
                                )}{" "}
                                Calling Summary
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/call-logs");
                                  handleAccordionChange(17, 17.2, "Call Logs");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 17.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 17.2 ? (
                                  <Icon.TelephoneForwardFill className="me-2" />
                                ) : (
                                  <Icon.TelephoneForward className="me-2 icon" />
                                )}{" "}
                                Call Logs
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/dialed-call-logs");
                                  handleAccordionChange(
                                    17,
                                    17.3,
                                    "Dialed Call Logs"
                                  );
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 17.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 17.3 ? (
                                  <Icon.TelephoneForwardFill className="me-2" />
                                ) : (
                                  <Icon.TelephoneForward className="me-2 icon" />
                                )}
                                Dialed Call Logs
                              </Button>

                              <Button
                                onClick={() => {
                                  handleAccordionChange(
                                    17,
                                    17.5,
                                    "Total Call Summary"
                                  );
                                  navigate("/dashboard/total-calling");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 17.5
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 17.5 ? (
                                  <Icon.TelephonePlusFill className="me-2" />
                                ) : (
                                  <Icon.TelephonePlus className="me-2 icon" />
                                )}{" "}
                                Total Call Summary
                              </Button>
                            </Accordion.Body>
                          </Accordion.Item>

                          {/* Japti */}
                          <Accordion.Item
                            eventKey="18"
                            className={
                              activeKeyRedux.activeKey === 18
                                ? "activeMenu dropDown"
                                : "dropDown"
                            }
                          >
                            <Accordion.Header
                              onClick={() => {
                                handleAccordionChange(
                                  18,
                                  activeKeyRedux.subActiveKey,
                                  activeKeyRedux.activeTab
                                );
                              }}
                            >
                              {activeKeyRedux?.activeKey === 18 ? (
                                <Icon.Coin className="me-2" />
                              ) : (
                                <Icon.Coin className="me-2 icon" />
                              )}
                              Japti Details
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/new-japti-notice");
                                  handleAccordionChange(18, 18.1, "Japti Notice");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 18.1
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 18.1 ? (
                                  <Icon.CardHeading className="me-2" />
                                ) : (
                                  <Icon.CardHeading className="me-2 icon" />
                                )}{" "}
                                Japti Notice
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/japti-karvai");
                                  handleAccordionChange(18, 18.2, "Japti Karvai");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 18.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 18.2 ? (
                                  <Icon.Coin className="me-2" />
                                ) : (
                                  <Icon.Coin className="me-2 icon" />
                                )}{" "}
                                Japti Karvai
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/japti-mukti");
                                  handleAccordionChange(18, 18.3, "Japti Mukti");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 18.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 18.3 ? (
                                  <Icon.Coin className="me-2" />
                                ) : (
                                  <Icon.Coin className="me-2 icon" />
                                )}{" "}
                                Japti Mukti
                              </Button>
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={19}
                            className={
                              activeKeyRedux.activeKey === 19
                                ? "activeMenu dropDown"
                                : "dropDown"
                            }
                          >
                            <Accordion.Header
                              onClick={() => {
                                handleAccordionChange(
                                  19,
                                  activeKeyRedux.subActiveKey,
                                  activeKeyRedux.activeTab
                                );
                              }}
                            >
                              {activeKeyRedux?.activeKey === 19 ? (
                                <Icon.Receipt className="me-2" />
                              ) : (
                                <Icon.Receipt className="me-2 icon" />
                              )}
                              Manage Bills
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/deleted-bill-history");
                                  handleAccordionChange(
                                    19,
                                    19.2,
                                    "Deleted Bill History"
                                  );
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 19.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 19.2 ? (
                                  <Icon.ReceiptCutoff className="me-2" />
                                ) : (
                                  <Icon.ReceiptCutoff className="me-2 icon" />
                                )}{" "}
                                Deleted Bill History
                              </Button>
                              {/* <Button
                                onClick={() => {
                                  navigate("/dashboard/deleted-bill-history");
                                  handleAccordionChange(
                                    19,
                                    19.3,
                                    "Deleted Bill History"
                                  );
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 19.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 19.3 ? (
                                  <Icon.ReceiptCutoff className="me-2" />
                                ) : (
                                  <Icon.ReceiptCutoff className="me-2 icon" />
                                )}{" "}
                                Rejected Bills
                              </Button> */}
                            </Accordion.Body>

                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="20"
                            onClick={() => {
                              handleAccordionChange(20, 20, "Rejected Bills");
                              navigate("/dashboard/rejected-list");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 20 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 20 ? (
                                <Icon.FileEarmarkExcelFill className="me-2" />
                              ) : (
                                <Icon.FileEarmarkExcel className="me-2 icon" />
                              )}
                              Rejected Bills
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={81}
                            onClick={() => {
                              handleAccordionChange(81, 81, "Update Mobile");
                              navigate("/dashboard/update-mobile");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 81 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 81 ? (
                                <Icon.TelephoneFill className="me-2" />
                              ) : (
                                <Icon.Telephone className="me-2 icon" />
                              )}
                              Update Mobile
                            </Accordion.Header>
                          </Accordion.Item>


                          {userState?.usertype_keyname[0] === "internalDev" && (
                            <Accordion.Item
                              eventKey="21"
                              onClick={() => {
                                handleAccordionChange(
                                  21,
                                  21,
                                  "Export Call Logs"
                                );
                                navigate("/dashboard/export-call-logs");
                              }}
                              className={
                                activeKeyRedux.activeKey === 21 ? "activeMenu" : ""
                              }
                            >
                              <Accordion.Header>
                                {activeKeyRedux.activeKey === 21 ? (
                                  <Icon.TelephonePlusFill className="me-2" />
                                ) : (
                                  <Icon.TelephonePlus className="me-2 icon" />
                                )}
                                Export Call Logs
                              </Accordion.Header>
                            </Accordion.Item>
                          )}

                          {userState?.usertype_keyname[0] === "internalDev" && (
                            <Accordion.Item
                              eventKey="21"
                              onClick={() => {
                                handleAccordionChange(
                                  22,
                                  22,
                                  "Import Telecalling"
                                );
                                navigate("/dashboard/telecalling-defaulter");
                              }}
                              className={
                                activeKeyRedux.activeKey === 22 ? "activeMenu" : ""
                              }
                            >
                              <Accordion.Header>
                                {activeKeyRedux.activeKey === 22 ? (
                                  <Icon.ClockFill className="me-2" />
                                ) : (
                                  <Icon.ClockHistory className="me-2 icon" />
                                )}
                                Telecalling Defaulter
                              </Accordion.Header>
                            </Accordion.Item>
                          )}
                        </Accordion>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion.Item>

                  {/* 2025-2026 */}
                  <Accordion.Item>
                    <Accordion.Item eventKey="2025-2026"
                      onClick={(event) => {
                        handleMenuChange(2, "2025-2026", event);
                      }}
                    >
                      <Accordion.Header className="newMenu">
                        2025-2026
                      </Accordion.Header>

                      <Accordion.Body style={{ padding: 0 }}>
                        <Accordion
                          flush
                          defaultActiveKey={activeKeyRedux?.activeKey}
                        >
                          {/* New Dashboard Sidebar from here */}
                          <Accordion.Item
                            eventKey={25}
                            onClick={() => {
                              handleAccordionChange(25, 25, "Bill Distribution");
                              navigate("/dashboard/new-home");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 25 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 25 ? (
                                <Icon.HouseDoorFill className="me-2" />
                              ) : (
                                <Icon.HouseDoor className="me-2 icon" />
                              )}
                              Bill Distribution
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="26"
                            onClick={() => {
                              handleAccordionChange(26, 26, "Manage Users");
                              navigate("/dashboard/manage-roles");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 26 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 26 ? (
                                <Icon.PersonFillGear className="me-2" />
                              ) : (
                                <Icon.PersonGear className="me-2 icon" />
                              )}
                              Manage Users
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="27"
                            onClick={() => {
                              handleAccordionChange(27, 27, "Property Visit Report");
                              navigate("/dashboard/new-visit-reports");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 27 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 27 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Property Visit Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={111}
                            onClick={() => {
                              handleAccordionChange(111, 111, "Staff Visit Report");
                              navigate("/dashboard/staff-visit-reports");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 111 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 111 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Staff Visit Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="28"
                            onClick={() => {
                              handleAccordionChange(
                                28,
                                28,
                                "Mahila Wise Bill Watap Report"
                              );
                              navigate("/dashboard/new-contractors");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 28 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 28 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Mahila Wise Bill Watap Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="29"
                            onClick={() => {
                              handleAccordionChange(
                                29,
                                29,
                                "Zone Wise Bill Analysis"
                              );
                              navigate("/dashboard/new-bill-analysis");
                            }}
                            className={activeKeyRedux?.activeKey === 29 ? "activeMenu" : ""}
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 29 ? (
                                <Icon.Receipt className="me-2" />
                              ) : (
                                <Icon.Receipt className="me-2 icon" />
                              )}
                              Zone Wise Bill Analysis
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey="30"
                            onClick={() => {
                              handleAccordionChange(
                                30,
                                30,
                                "Gatwise Bill Analysis"
                              );
                              navigate("/dashboard/gatwise-bill-analysis");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 30 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 30 ? (
                                <Icon.Receipt className="me-2" />
                              ) : (
                                <Icon.Receipt className="me-2 icon" />
                              )}
                              Gatwise Bill Analysis
                            </Accordion.Header>
                          </Accordion.Item>

                          {/* <Accordion.Item
                          eventKey="16"
                          onClick={() => {
                            handleAccordionChange(16, 16, "Japti Notice");
                            navigate("/dashboard/new-japti-notice");
                          }}
                          className={
                            activeKeyRedux?.activeKey === 16 ? "activeMenu" : ""
                          }
                        >
                          <Accordion.Header>
                            {activeKeyRedux?.activeKey === 16 ? (
                              <Icon.CardHeading className="me-2" />
                            ) : (
                              <Icon.CardHeading className="me-2 icon" />
                            )}
                            Japti Notice
                          </Accordion.Header>
                        </Accordion.Item> */}

                          {/* Telecalling */}
                          <Accordion.Item
                            eventKey={31}
                            className={
                              activeKeyRedux.activeKey === 31
                                ? "activeMenu dropDown"
                                : "dropDown"
                            }
                          >
                            <Accordion.Header
                              onClick={() => {
                                handleAccordionChange(
                                  31,
                                  activeKeyRedux.subActiveKey,
                                  activeKeyRedux.activeTab,
                                );
                              }}
                            >
                              {activeKeyRedux?.activeKey === 31 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Manage Telecalling
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/call-summary");
                                  handleAccordionChange(31, 31.1, "Call Summary");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 31.1
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 31.1 ? (
                                  <Icon.ChatTextFill className="me-2" />
                                ) : (
                                  <Icon.ChatText className="me-2 icon" />
                                )}{" "}
                                Calling Summary
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/call-logs");
                                  handleAccordionChange(31, 31.2, "Call Logs");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 31.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 31.2 ? (
                                  <Icon.TelephoneForwardFill className="me-2" />
                                ) : (
                                  <Icon.TelephoneForward className="me-2 icon" />
                                )}{" "}
                                Call Logs
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/dialed-call-logs");
                                  handleAccordionChange(
                                    31,
                                    31.3,
                                    "Dialed Call Logs"
                                  );
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 31.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 31.3 ? (
                                  <Icon.TelephoneForwardFill className="me-2" />
                                ) : (
                                  <Icon.TelephoneForward className="me-2 icon" />
                                )}
                                Dialed Call Logs
                              </Button>
                              <Button
                                onClick={() => {
                                  handleAccordionChange(
                                    31,
                                    31.5,
                                    "Total Call Summary"
                                  );
                                  navigate("/dashboard/total-calling");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 31.5
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 31.5 ? (
                                  <Icon.TelephonePlusFill className="me-2" />
                                ) : (
                                  <Icon.TelephonePlus className="me-2 icon" />
                                )}{" "}
                                Total Call Summary
                              </Button>
                            </Accordion.Body>
                          </Accordion.Item>

                          {/* Japti */}
                          <Accordion.Item
                            eventKey="32"
                            className={
                              activeKeyRedux.activeKey === 32
                                ? "activeMenu dropDown"
                                : "dropDown"
                            }
                          >
                            <Accordion.Header
                              onClick={() => {
                                handleAccordionChange(
                                  32,
                                  activeKeyRedux.subActiveKey,
                                  activeKeyRedux.activeTab
                                );
                              }}
                            >
                              {activeKeyRedux?.activeKey === 32 ? (
                                <Icon.Coin className="me-2" />
                              ) : (
                                <Icon.Coin className="me-2 icon" />
                              )}
                              Japti Details
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/new-japti-notice");
                                  handleAccordionChange(32, 32.1, "Japti Notice");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 32.1
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 32.1 ? (
                                  <Icon.CardHeading className="me-2" />
                                ) : (
                                  <Icon.CardHeading className="me-2 icon" />
                                )}{" "}
                                Japti Notice
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/japti-karvai");
                                  handleAccordionChange(32, 32.2, "Japti Karvai");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 32.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 32.2 ? (
                                  <Icon.Coin className="me-2" />
                                ) : (
                                  <Icon.Coin className="me-2 icon" />
                                )}{" "}
                                Japti Karvai
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/japti-mukti");
                                  handleAccordionChange(32, 32.3, "Japti Mukti");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 32.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 32.3 ? (
                                  <Icon.Coin className="me-2" />
                                ) : (
                                  <Icon.Coin className="me-2 icon" />
                                )}{" "}
                                Japti Mukti
                              </Button>
                            </Accordion.Body>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={33}
                            className={
                              activeKeyRedux.activeKey === 33
                                ? "activeMenu dropDown"
                                : "dropDown"
                            }
                          >
                            <Accordion.Header
                              onClick={() => {
                                handleAccordionChange(
                                  33,
                                  activeKeyRedux.subActiveKey,
                                  activeKeyRedux.activeTab
                                );
                              }}
                            >
                              {activeKeyRedux?.activeKey === 33 ? (
                                <Icon.Receipt className="me-2" />
                              ) : (
                                <Icon.Receipt className="me-2 icon" />
                              )}
                              Manage Bills
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/deleted-bill-history");
                                  handleAccordionChange(
                                    33,
                                    33.2,
                                    "Deleted Bill History"
                                  );
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 33.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 33.2 ? (
                                  <Icon.ReceiptCutoff className="me-2" />
                                ) : (
                                  <Icon.ReceiptCutoff className="me-2 icon" />
                                )}{" "}
                                Deleted Bill History
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/rejected-list");
                                  handleAccordionChange(
                                    33,
                                    33.3,
                                    "Rejected Bills"
                                  );
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 33.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 33.3 ? (
                                  <Icon.ReceiptCutoff className="me-2" />
                                ) : (
                                  <Icon.ReceiptCutoff className="me-2 icon" />
                                )}{" "}
                                Rejected Bills
                              </Button>
                            </Accordion.Body>
                          </Accordion.Item>

                          {/* <Accordion.Item
                            eventKey="34"
                            onClick={() => {
                              handleAccordionChange(34, 34, "Rejected Bills");
                              navigate("/dashboard/rejected-list");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 34 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 34 ? (
                                <Icon.FileEarmarkExcelFill className="me-2" />
                              ) : (
                                <Icon.FileEarmarkExcel className="me-2 icon" />
                              )}
                              Rejected Bills
                            </Accordion.Header>
                          </Accordion.Item> */}

                          {userState?.usertype_keyname[0] === "internalDev" && (
                            <Accordion.Item
                              eventKey="35"
                              onClick={() => {
                                handleAccordionChange(
                                  35,
                                  35,
                                  "Export Call Logs"
                                );
                                navigate("/dashboard/export-call-logs");
                              }}
                              className={
                                activeKeyRedux.activeKey === 35 ? "activeMenu" : ""
                              }
                            >
                              <Accordion.Header>
                                {activeKeyRedux.activeKey === 35 ? (
                                  <Icon.TelephonePlusFill className="me-2" />
                                ) : (
                                  <Icon.TelephonePlus className="me-2 icon" />
                                )}
                                Export Call Logs
                              </Accordion.Header>
                            </Accordion.Item>
                          )}

                          {userState?.usertype_keyname[0] === "internalDev" && (
                            <Accordion.Item
                              eventKey="36"
                              onClick={() => {
                                handleAccordionChange(
                                  36,
                                  36,
                                  "Import Telecalling"
                                );
                                navigate("/dashboard/telecalling-defaulter");
                              }}
                              className={
                                activeKeyRedux.activeKey === 36 ? "activeMenu" : ""
                              }
                            >
                              <Accordion.Header>
                                {activeKeyRedux.activeKey === 36 ? (
                                  <Icon.ClockFill className="me-2" />
                                ) : (
                                  <Icon.ClockHistory className="me-2 icon" />
                                )}
                                Telecalling Defaulter
                              </Accordion.Header>
                            </Accordion.Item>
                          )}


                          {/* image verification */}
                          <Accordion.Item
                            eventKey="44"
                            className={activeKeyRedux.activeKey === 44 ? "activeMenu dropDown" : "dropDown"}
                          >
                            <Accordion.Header
                              onClick={() => {
                                handleAccordionChange(44, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab);
                              }}
                            >
                              {activeKeyRedux?.activeKey === 44 ? (
                                <Icon.ImageFill className="me-2" />
                              ) : (
                                <Icon.Images className="me-2 icon" />
                              )}
                              Verification
                            </Accordion.Header>

                            <Accordion.Body className="d-flex flex-column">
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/imageverification");
                                  handleAccordionChange(44, 44.1, " Image Verification");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 44.1
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 44.1 ? (
                                  <Icon.ShieldFillCheck className="me-2" />
                                ) : (
                                  <Icon.ShieldCheck className="me-2 icon" />
                                )}{" "}
                                Image Verification
                              </Button>
                              <Button
                                onClick={() => {
                                  navigate("/dashboard/rejected");
                                  handleAccordionChange(44, 44.2, " Image Verification History");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 44.2
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 44.2 ? (
                                  <Icon.ImageFill className="me-2" />
                                ) : (
                                  <Icon.Image className="me-2 icon" />
                                )}{" "}
                                Image Verification History
                              </Button>

                              <Button
                                onClick={() => {
                                  navigate("/dashboard/surveyverification");
                                  handleAccordionChange(44, 44.3, "Survey Verification");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 44.3
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 44.3 ? (
                                  <Icon.ShieldFillCheck className="me-2" />
                                ) : (
                                  <Icon.ShieldCheck className="me-2 icon" />
                                )}{" "}
                                Survey Verification
                              </Button>

                              <Button
                                onClick={() => {
                                  navigate("/dashboard/surveyrejected");
                                  handleAccordionChange(44, 44.4, "Survey Verification History");
                                }}
                                className={
                                  activeKeyRedux?.subActiveKey === 44.4
                                    ? "accordionNavActive mb-3"
                                    : "accordionNav mb-3"
                                }
                              >
                                {activeKeyRedux?.subActiveKey === 44.4 ? (
                                  <Icon.ImageFill className="me-2" />
                                ) : (
                                  <Icon.Image className="me-2 icon" />
                                )}{" "}
                                Survey Verification History
                              </Button>

                            </Accordion.Body>
                          </Accordion.Item>

                          {/* Palika User Wise Bill Watap Report */}
                          <Accordion.Item
                            eventKey="45"
                            onClick={() => {
                              handleAccordionChange(
                                45,
                                45,
                                "Palika User Wise Bill Watap Report"
                              );
                              navigate("/dashboard/palika-users");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 45 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 45 ? (
                                <Icon.PeopleFill className="me-2" />
                              ) : (
                                <Icon.People className="me-2 icon" />
                              )}
                              Palika User Wise Bill Watap Report
                            </Accordion.Header>
                          </Accordion.Item>

                          <Accordion.Item
                            eventKey={82}
                            onClick={() => {
                              handleAccordionChange(82, 82, "Update Mobile");
                              navigate("/dashboard/update-mobile");
                            }}
                            className={
                              activeKeyRedux?.activeKey === 82 ? "activeMenu" : ""
                            }
                          >
                            <Accordion.Header>
                              {activeKeyRedux?.activeKey === 82 ? (
                                <Icon.TelephoneFill className="me-2" />
                              ) : (
                                <Icon.Telephone className="me-2 icon" />
                              )}
                              Update Mobile
                            </Accordion.Header>
                          </Accordion.Item>
                        </Accordion>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion.Item>
                </Accordion>
              </>
            ) : (
              ""
            )}

            {/* for supervisor */}
            {userState.usertype_keyname[0] === "supervisor" ? (
              <Accordion flush>
                <Accordion.Item
                  eventKey={0}
                  onClick={() => {
                    handleAccordionChange(0, 0, "Home");
                    navigate("/dashboard");
                  }}
                  className={activeKeyRedux.activeKey === 0 ? "activeMenu" : ""}
                >
                  <Accordion.Header>
                    {activeKeyRedux.activeKey === 0 ? (
                      <Icon.HouseDoorFill className="me-2" />
                    ) : (
                      <Icon.HouseDoor className="me-2 icon" />
                    )}
                    Home
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={1}
                  onClick={() => {
                    handleAccordionChange(1, 1, "Manage Roles");
                    navigate("/dashboard/manage-roles");
                  }}
                  className={activeKeyRedux.activeKey === 1 ? "activeMenu" : ""}
                >
                  <Accordion.Header>
                    {activeKeyRedux.activeKey === 1 ? (
                      <Icon.PersonFillGear className="me-2" />
                    ) : (
                      <Icon.PersonGear className="me-2 icon" />
                    )}
                    Manage Users
                  </Accordion.Header>
                </Accordion.Item>
              </Accordion>
            ) : (
              ""
            )}

            {/* for zonalofficer */}
            {userState.usertype_keyname[0] === "zonalofficer" ? (
              <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>
                {/* New Dashboard Sidebar from here */}
                <Accordion.Item
                  eventKey={10}
                  onClick={() => {

                    handleAccordionChange(10, 10, "Bill Distribution");
                    navigate("/dashboard/new-home");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 10 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 10 ? (
                      <Icon.HouseDoorFill className="me-2" />
                    ) : (
                      <Icon.HouseDoor className="me-2 icon" />
                    )}
                    Bill Distribution
                  </Accordion.Header>
                </Accordion.Item>

                {/* <Accordion.Item
                eventKey="2"
                onClick={() => {
                  handleAccordionChange(14, 14, "Manage Users");
                  navigate("/dashboard/manage-roles");
                }}
                className={
                  activeKeyRedux?.activeKey === 14 ? "activeMenu" : ""
                }
              >
                <Accordion.Header>
                  {activeKeyRedux?.activeKey === 14 ? (
                    <Icon.PersonFillGear className="me-2" />
                  ) : (
                    <Icon.PersonGear className="me-2 icon" />
                  )}
                  Manage Users
                </Accordion.Header>
              </Accordion.Item> */}

                <Accordion.Item
                  eventKey="11"
                  onClick={() => {
                    handleAccordionChange(11, 11, "Property Visit Report");
                    navigate("/dashboard/new-visit-reports");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 11 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 11 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Property Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={112}
                  onClick={() => {
                    handleAccordionChange(112, 112, "Staff Visit Report");
                    navigate("/dashboard/staff-visit-reports");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 112 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 112 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Staff Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="12"
                  onClick={() => {
                    handleAccordionChange(
                      12,
                      12,
                      "Mahila Wise Bill Watap Report"
                    );
                    navigate("/dashboard/new-contractors");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 12 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 12 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Mahila Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="13"
                  onClick={() => {
                    handleAccordionChange(13, 13, "Zone Wise Bill Analysis");
                    navigate("/dashboard/new-bill-analysis");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 13 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 13 ? (
                      <Icon.Receipt className="me-2" />
                    ) : (
                      <Icon.Receipt className="me-2 icon" />
                    )}
                    Zone Wise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="113"
                  onClick={() => {
                    handleAccordionChange(113, 113, "Gat Lipik Analysis");
                    navigate("/dashboard/gatlipik-report-analysis");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 113 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 113 ? (
                      <Icon.Receipt className="me-2" />
                    ) : (
                      <Icon.Receipt className="me-2 icon" />
                    )}
                    Gat Lipik Report Analysis
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="18"
                  onClick={() => {
                    handleAccordionChange(18, 18, "Gatwise Bill Analysis");
                    navigate("/dashboard/gatwise-bill-analysis");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 18 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 18 ? (
                      <Icon.Receipt className="me-2" />
                    ) : (
                      <Icon.Receipt className="me-2 icon" />
                    )}
                    Gatwise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>

                {/* Telecalling */}
                <Accordion.Item
                  eventKey={311}
                  className={
                    activeKeyRedux.activeKey === 311
                      ? "activeMenu dropDown"
                      : "dropDown"
                  }
                >
                  <Accordion.Header
                    onClick={() => {
                      handleAccordionChange(
                        311,
                        activeKeyRedux.subActiveKey,
                        activeKeyRedux.activeTab,
                      );
                    }}
                  >
                    {activeKeyRedux?.activeKey === 311 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Manage Telecalling
                  </Accordion.Header>

                  <Accordion.Body className="d-flex flex-column">
                    <Button
                      onClick={() => {
                        navigate("/dashboard/zonal-call-summary");
                        handleAccordionChange(311, 311.1, "Call Summary");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 311.1
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 311.1 ? (
                        <Icon.ChatTextFill className="me-2" />
                      ) : (
                        <Icon.ChatText className="me-2 icon" />
                      )}{" "}
                      Calling Summary
                    </Button>
                    <Button
                      onClick={() => {
                        navigate("/dashboard/zonal-call-logs");
                        handleAccordionChange(311, 311.2, "Call Logs");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 311.2
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 311.2 ? (
                        <Icon.TelephoneForwardFill className="me-2" />
                      ) : (
                        <Icon.TelephoneForward className="me-2 icon" />
                      )}{" "}
                      Call Logs
                    </Button>
                    <Button
                      onClick={() => {
                        navigate("/dashboard/zonal-dialed-call-logs");
                        handleAccordionChange(
                          311,
                          311.3,
                          "Dialed Call Logs"
                        );
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 311.3
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 311.3 ? (
                        <Icon.TelephoneForwardFill className="me-2" />
                      ) : (
                        <Icon.TelephoneForward className="me-2 icon" />
                      )}
                      Dialed Call Logs
                    </Button>
                    {/* <Button
                      onClick={() => {
                        navigate("/dashboard/update-mobile");
                        handleAccordionChange(311, 311.4, "Update Mobile");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 311.4
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 311.4 ? (
                        <Icon.TelephoneFill className="me-2" />
                      ) : (
                        <Icon.Telephone className="me-2 icon" />
                      )}{" "}
                      Update Mobile
                    </Button> */}
                    <Button
                      onClick={() => {
                        handleAccordionChange(
                          311,
                          311.5,
                          "Total Call Summary"
                        );
                        navigate("/dashboard/zonal-total-calling");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 311.5
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 311.5 ? (
                        <Icon.TelephonePlusFill className="me-2" />
                      ) : (
                        <Icon.TelephonePlus className="me-2 icon" />
                      )}{" "}
                      Total Call Summary
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                {/* japti data */}
                <Accordion.Item
                  eventKey="16"
                  onClick={() => {
                    handleAccordionChange(16, 16, "Japti Notice");
                    // navigate("/dashboard/new-japti-notice");
                    navigate("/dashboard/zonal-japti-notice")
                  }}
                  className={
                    activeKeyRedux?.activeKey === 16 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 16 ? (
                      <Icon.CardHeading className="me-2" />
                    ) : (
                      <Icon.CardHeading className="me-2 icon" />
                    )}
                    Japti Notice
                  </Accordion.Header>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="22"
                  onClick={() => {
                    handleAccordionChange(22, 22, "Japti Karvai");
                    // navigate("/dashboard/new-japti-notice");
                    navigate("/dashboard/zonal-japti-karvai")
                  }}
                  className={
                    activeKeyRedux?.activeKey === 22 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 22 ? (
                      <Icon.CardHeading className="me-2" />
                    ) : (
                      <Icon.CardHeading className="me-2 icon" />
                    )}
                    Japti Karvai
                  </Accordion.Header>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="23"
                  onClick={() => {
                    handleAccordionChange(23, 23, "Japti Mukti");
                    // navigate("/dashboard/new-japti-notice");
                    navigate("/dashboard/zonal-japti-mukti")
                  }}
                  className={
                    activeKeyRedux?.activeKey === 23 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 23 ? (
                      <Icon.CardHeading className="me-2" />
                    ) : (
                      <Icon.CardHeading className="me-2 icon" />
                    )}
                    Japti Mukti
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={15}
                  className={
                    activeKeyRedux.activeKey === 15
                      ? "activeMenu dropDown"
                      : "dropDown"
                  }
                >
                  <Accordion.Header
                    onClick={() => {
                      handleAccordionChange(
                        15,
                        activeKeyRedux.subActiveKey,
                        activeKeyRedux.activeTab
                      );
                    }}
                  >
                    {activeKeyRedux?.activeKey === 15 ? (
                      <Icon.Receipt className="me-2" />
                    ) : (
                      <Icon.Receipt className="me-2 icon" />
                    )}
                    Manage Bills
                  </Accordion.Header>

                  <Accordion.Body className="d-flex flex-column">
                    <Button
                      onClick={() => {
                        navigate("/dashboard/bill-report");
                        handleAccordionChange(15, 15.1, "Bill Report");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 15.1
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 15.1 ? (
                        <Icon.ReceiptCutoff className="me-2" />
                      ) : (
                        <Icon.ReceiptCutoff className="me-2 icon" />
                      )}{" "}
                      Bill Report
                    </Button>

                    <Button
                      onClick={() => {
                        navigate("/dashboard/deleted-bill-history");
                        handleAccordionChange(15, 15.2, "Deleted Bill History");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 15.2
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 15.2 ? (
                        <Icon.ReceiptCutoff className="me-2" />
                      ) : (
                        <Icon.ReceiptCutoff className="me-2 icon" />
                      )}{" "}
                      Deleted Bill History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="19"
                  className={activeKeyRedux.activeKey === 19 ? "activeMenu dropDown" : "dropDown"}
                >
                  <Accordion.Header
                    onClick={() => {
                      handleAccordionChange(19, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab);
                    }}
                  >
                    {activeKeyRedux?.activeKey === 19 ? (
                      <Icon.ImageFill className="me-2" />
                    ) : (
                      <Icon.Images className="me-2 icon" />
                    )}
                    Verification
                  </Accordion.Header>

                  <Accordion.Body className="d-flex flex-column">
                    <Button
                      onClick={() => {
                        navigate("/dashboard/imageverification");
                        handleAccordionChange(19, 19.1, "Image Verification");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 19.1
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 19.1 ? (
                        <Icon.ShieldFillCheck className="me-2" />
                      ) : (
                        <Icon.ShieldCheck className="me-2 icon" />
                      )}{" "}
                      Image Verification
                    </Button>
                    <Button
                      onClick={() => {
                        navigate("/dashboard/rejected");
                        handleAccordionChange(19, 19.2, " Image Verification History");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 19.2
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 19.2 ? (
                        <Icon.ImageFill className="me-2" />
                      ) : (
                        <Icon.Image className="me-2 icon" />
                      )}{" "}
                      Image Verification History
                    </Button>

                    <Button
                      onClick={() => {
                        navigate("/dashboard/surveyverification");
                        handleAccordionChange(19, 19.3, "Survey Verification");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 19.3
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 19.3 ? (
                        <Icon.ShieldFillCheck className="me-2" />
                      ) : (
                        <Icon.ShieldCheck className="me-2 icon" />
                      )}{" "}
                      Survey Verification
                    </Button>

                    <Button
                      onClick={() => {
                        navigate("/dashboard/surveyrejected");
                        handleAccordionChange(19, 19.4, "Survey Verification History");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 19.4
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 19.4 ? (
                        <Icon.ImageFill className="me-2" />
                      ) : (
                        <Icon.Image className="me-2 icon" />
                      )}{" "}
                      Survey Verification History
                    </Button>

                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="20"
                  onClick={() => {
                    handleAccordionChange(
                      20,
                      20,
                      "Palika User Wise Bill Watap Report"
                    );
                    navigate("/dashboard/palika-users");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 20 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 20 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Palika User Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>
              </Accordion>
            ) : (
              ""
            )}

            {/* for gatlipik */}
            {userState.usertype_keyname[0] === "gatlipik" ? (
              <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>
                {/* New Dashboard Sidebar from here */}
                <Accordion.Item
                  eventKey={51}
                  onClick={() => {
                    handleAccordionChange(51, 51, "Bill Distribution");
                    navigate("/dashboard/new-gat-home");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 51 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 51 ? (
                      <Icon.HouseDoorFill className="me-2" />
                    ) : (
                      <Icon.HouseDoor className="me-2 icon" />
                    )}
                    Bill Distribution
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={52}
                  onClick={() => {
                    handleAccordionChange(52, 52, "Property Visit Report");
                    navigate("/dashboard/gat-property-report");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 52 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 52 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Property Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={53}
                  onClick={() => {
                    handleAccordionChange(
                      53,
                      53,
                      "Mahila Wise Bill Watap Report"
                    );
                    navigate("/dashboard/gat-mahila-report");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 53 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 53 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Mahila Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={54}
                  onClick={() => {
                    handleAccordionChange(54, 54, "Gatwise Bill Analysis");
                    navigate("/dashboard/gat-wise-bill-analysis");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 54 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 54 ? (
                      <Icon.Receipt className="me-2" />
                    ) : (
                      <Icon.Receipt className="me-2 icon" />
                    )}
                    Gatwise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>


                {/* Telecalling */}
                <Accordion.Item
                  eventKey={312}
                  className={
                    activeKeyRedux.activeKey === 312
                      ? "activeMenu dropDown"
                      : "dropDown"
                  }
                >
                  <Accordion.Header
                    onClick={() => {
                      handleAccordionChange(
                        312,
                        activeKeyRedux.subActiveKey,
                        activeKeyRedux.activeTab,
                      );
                    }}
                  >
                    {activeKeyRedux?.activeKey === 312 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Manage Telecalling
                  </Accordion.Header>

                  <Accordion.Body className="d-flex flex-column">
                    <Button
                      onClick={() => {
                        navigate("/dashboard/gat-call-summary");
                        handleAccordionChange(312, 312.1, "Call Summary");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 312.1
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 312.1 ? (
                        <Icon.ChatTextFill className="me-2" />
                      ) : (
                        <Icon.ChatText className="me-2 icon" />
                      )}{" "}
                      Calling Summary
                    </Button>
                    <Button
                      onClick={() => {
                        navigate("/dashboard/gat-call-logs");
                        handleAccordionChange(312, 312.2, "Call Logs");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 312.2
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 312.2 ? (
                        <Icon.TelephoneForwardFill className="me-2" />
                      ) : (
                        <Icon.TelephoneForward className="me-2 icon" />
                      )}{" "}
                      Call Logs
                    </Button>
                    <Button
                      onClick={() => {
                        navigate("/dashboard/gat-dialed-call-logs");
                        handleAccordionChange(
                          312,
                          312.3,
                          "Dialed Call Logs"
                        );
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 312.3
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 312.3 ? (
                        <Icon.TelephoneForwardFill className="me-2" />
                      ) : (
                        <Icon.TelephoneForward className="me-2 icon" />
                      )}
                      Dialed Call Logs
                    </Button>
                    {/* <Button
                      onClick={() => {
                        navigate("/dashboard/update-mobile");
                        handleAccordionChange(312, 312.4, "Update Mobile");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 312.4
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 312.4 ? (
                        <Icon.TelephoneFill className="me-2" />
                      ) : (
                        <Icon.Telephone className="me-2 icon" />
                      )}{" "}
                      Update Mobile
                    </Button> */}
                    <Button
                      onClick={() => {
                        handleAccordionChange(
                          312,
                          312.5,
                          "Total Call Summary"
                        );
                        navigate("/dashboard/gat-total-calling");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 312.5
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 312.5 ? (
                        <Icon.TelephonePlusFill className="me-2" />
                      ) : (
                        <Icon.TelephonePlus className="me-2 icon" />
                      )}{" "}
                      Total Call Summary
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                {/* japti data */}
                <Accordion.Item
                  eventKey={55}
                  onClick={() => {
                    handleAccordionChange(55, 55, "Japti Notice");
                    navigate("/dashboard/gat-japti-notice");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 55 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 55 ? (
                      <Icon.CardHeading className="me-2" />
                    ) : (
                      <Icon.CardHeading className="me-2 icon" />
                    )}
                    Japti Notice
                  </Accordion.Header>
                </Accordion.Item>
                {/* japti karwai */}
                <Accordion.Item
                  eventKey={59}
                  onClick={() => {
                    handleAccordionChange(59, 59, "Japti Karwai");
                    navigate("/dashboard/gat-japti-karwai");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 59 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 59 ? (
                      <Icon.CardHeading className="me-2" />
                    ) : (
                      <Icon.CardHeading className="me-2 icon" />
                    )}
                    Japti Karwai
                  </Accordion.Header>
                </Accordion.Item>
                {/* japti mukti */}
                <Accordion.Item
                  eventKey={60}
                  onClick={() => {
                    handleAccordionChange(60, 60, "Japti Mukti");
                    navigate("/dashboard/gat-japti-mukti");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 60 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 60 ? (
                      <Icon.CardHeading className="me-2" />
                    ) : (
                      <Icon.CardHeading className="me-2 icon" />
                    )}
                    Japti Mukti
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={56}
                  className={
                    activeKeyRedux.activeKey === 56
                      ? "activeMenu dropDown"
                      : "dropDown"
                  }
                >
                  <Accordion.Header
                    onClick={() => {
                      handleAccordionChange(
                        56,
                        activeKeyRedux.subActiveKey,
                        activeKeyRedux.activeTab
                      );
                    }}
                  >
                    {activeKeyRedux?.activeKey === 56 ? (
                      <Icon.Receipt className="me-2" />
                    ) : (
                      <Icon.Receipt className="me-2 icon" />
                    )}
                    Manage Bills
                  </Accordion.Header>

                  <Accordion.Body className="d-flex flex-column">
                    <Button
                      onClick={() => {
                        navigate("/dashboard/gat-bill-report");
                        handleAccordionChange(56, 56.1, "Bill Report");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 56.1
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 56.1 ? (
                        <Icon.ReceiptCutoff className="me-2" />
                      ) : (
                        <Icon.ReceiptCutoff className="me-2 icon" />
                      )}{" "}
                      Bill Report
                    </Button>

                    <Button
                      onClick={() => {
                        navigate("/dashboard/gat-deleted-bill-history");
                        handleAccordionChange(56, 56.2, "Deleted Bill History");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 56.2
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 56.2 ? (
                        <Icon.ReceiptCutoff className="me-2" />
                      ) : (
                        <Icon.ReceiptCutoff className="me-2 icon" />
                      )}{" "}
                      Deleted Bill History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={57}
                  className={activeKeyRedux.activeKey === 57 ? "activeMenu dropDown" : "dropDown"}
                >
                  <Accordion.Header
                    onClick={() => {
                      handleAccordionChange(57, activeKeyRedux.subActiveKey, activeKeyRedux.activeTab);
                    }}
                  >
                    {activeKeyRedux?.activeKey === 57 ? (
                      <Icon.ImageFill className="me-2" />
                    ) : (
                      <Icon.Images className="me-2 icon" />
                    )}
                    Verification
                  </Accordion.Header>

                  <Accordion.Body className="d-flex flex-column">
                    <Button
                      onClick={() => {
                        navigate("/dashboard/imageverification");
                        handleAccordionChange(57, 57.1, "Image Verification");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 57.1
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 57.1 ? (
                        <Icon.ShieldFillCheck className="me-2" />
                      ) : (
                        <Icon.ShieldCheck className="me-2 icon" />
                      )}{" "}
                      Image Verification
                    </Button>
                    <Button
                      onClick={() => {
                        navigate("/dashboard/rejected");
                        handleAccordionChange(57, 57.2, " Image Verification History");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 57.2
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 57.2 ? (
                        <Icon.ImageFill className="me-2" />
                      ) : (
                        <Icon.Image className="me-2 icon" />
                      )}{" "}
                      Image Verification History
                    </Button>

                    <Button
                      onClick={() => {
                        navigate("/dashboard/surveyverification");
                        handleAccordionChange(57, 57.3, "Survey Verification");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 57.3
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 57.3 ? (
                        <Icon.ShieldFillCheck className="me-2" />
                      ) : (
                        <Icon.ShieldCheck className="me-2 icon" />
                      )}{" "}
                      Survey Verification
                    </Button>

                    <Button
                      onClick={() => {
                        navigate("/dashboard/surveyrejected");
                        handleAccordionChange(57, 57.4, "Survey Verification History");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 57.4
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 57.4 ? (
                        <Icon.ImageFill className="me-2" />
                      ) : (
                        <Icon.Image className="me-2 icon" />
                      )}{" "}
                      Survey Verification History
                    </Button>

                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item
                  eventKey="58"
                  onClick={() => {
                    handleAccordionChange(
                      58,
                      58,
                      "Palika User Wise Bill Watap Report"
                    );
                    navigate("/dashboard/palika-users");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 58 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 58 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Palika User Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>
              </Accordion>
            ) : (
              ""
            )}

            {/* for mavim */}
            {userState.usertype_keyname[0] === "mavim" ? (
              <Accordion flush defaultActiveKey={activeKeyRedux?.activeKey}>
                {/* New Dashboard Sidebar from here */}
                <Accordion.Item
                  eventKey={10}
                  onClick={() => {
                    handleAccordionChange(10, 10, "Bill Distribution");
                    navigate("/dashboard/new-home");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 10 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 10 ? (
                      <Icon.HouseDoorFill className="me-2" />
                    ) : (
                      <Icon.HouseDoor className="me-2 icon" />
                    )}
                    Bill Distribution
                  </Accordion.Header>
                </Accordion.Item>

                {/* <Accordion.Item
                        eventKey="2"
                        onClick={() => {
                          handleAccordionChange(14, 14, "Manage Users");
                          navigate("/dashboard/manage-roles");
                        }}
                        className={
                          activeKeyRedux?.activeKey === 14 ? "activeMenu" : ""
                        }
                      >
                        <Accordion.Header>
                          {activeKeyRedux?.activeKey === 14 ? (
                            <Icon.PersonFillGear className="me-2" />
                          ) : (
                            <Icon.PersonGear className="me-2 icon" />
                          )}
                          Manage Users
                        </Accordion.Header>
                      </Accordion.Item> */}

                <Accordion.Item
                  eventKey="11"
                  onClick={() => {
                    handleAccordionChange(11, 11, "Property Visit Report");
                    navigate("/dashboard/new-visit-reports");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 11 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 11 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Property Visit Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="12"
                  onClick={() => {
                    handleAccordionChange(
                      12,
                      12,
                      "Mahila Wise Bill Watap Report"
                    );
                    navigate("/dashboard/new-contractors");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 12 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 12 ? (
                      <Icon.PeopleFill className="me-2" />
                    ) : (
                      <Icon.People className="me-2 icon" />
                    )}
                    Mahila Wise Bill Watap Report
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="13"
                  onClick={() => {
                    handleAccordionChange(13, 13, "Zone Wise Bill Analysis");
                    navigate("/dashboard/new-bill-analysis");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 13 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 13 ? (
                      <Icon.Receipt className="me-2" />
                    ) : (
                      <Icon.Receipt className="me-2 icon" />
                    )}
                    Zone Wise Bill Analysis
                  </Accordion.Header>
                </Accordion.Item>

                <Accordion.Item
                  eventKey={15}
                  className={
                    activeKeyRedux.activeKey === 15
                      ? "activeMenu dropDown"
                      : "dropDown"
                  }
                >
                  <Accordion.Header
                    onClick={() => {
                      handleAccordionChange(
                        15,
                        activeKeyRedux.subActiveKey,
                        activeKeyRedux.activeTab
                      );
                    }}
                  >
                    {activeKeyRedux?.activeKey === 15 ? (
                      <Icon.Receipt className="me-2" />
                    ) : (
                      <Icon.Receipt className="me-2 icon" />
                    )}
                    Manage Bills
                  </Accordion.Header>

                  <Accordion.Body className="d-flex flex-column">
                    <Button
                      onClick={() => {
                        navigate("/dashboard/bill-report");
                        handleAccordionChange(15, 15.1, "Bill Report");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 15.1
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 15.1 ? (
                        <Icon.ReceiptCutoff className="me-2" />
                      ) : (
                        <Icon.ReceiptCutoff className="me-2 icon" />
                      )}{" "}
                      Bill Report
                    </Button>

                    <Button
                      onClick={() => {
                        navigate("/dashboard/deleted-bill-history");
                        handleAccordionChange(15, 15.2, "Deleted Bill History");
                      }}
                      className={
                        activeKeyRedux?.subActiveKey === 15.2
                          ? "accordionNavActive mb-3"
                          : "accordionNav mb-3"
                      }
                    >
                      {activeKeyRedux?.subActiveKey === 15.2 ? (
                        <Icon.ReceiptCutoff className="me-2" />
                      ) : (
                        <Icon.ReceiptCutoff className="me-2 icon" />
                      )}{" "}
                      Deleted Bill History
                    </Button>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item
                  eventKey="17"
                  onClick={() => {
                    handleAccordionChange(17, 17, "Rejected Bills");
                    navigate("/dashboard/rejected-list");
                  }}
                  className={
                    activeKeyRedux?.activeKey === 17 ? "activeMenu" : ""
                  }
                >
                  <Accordion.Header>
                    {activeKeyRedux?.activeKey === 17 ? (
                      <Icon.FileEarmarkExcelFill className="me-2" />
                    ) : (
                      <Icon.FileEarmarkExcel className="me-2 icon" />
                    )}
                    Rejected Bills
                  </Accordion.Header>
                </Accordion.Item>
              </Accordion>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="pb-4 ps-2">
          <Button className="btn-logout w-100" onClick={handleLogout}>
            {loader ? (
              <Spinner animation="border" variant="light" className="spinner" />
            ) : (
              <>
                <Icon.BoxArrowLeft size={20} className="me-2" />
                Logout
              </>
            )}
          </Button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;

{
  /* <Accordion.Item eventKey="3" onClick={ () => {setActivekey(3); navigate("/admin/contractors"); }} className={activeKey===3 ? "activeMenu": ""}>
           <Accordion.Header className='dropDown'>{activeKey===3 ? <Icon.PlusCircleFill className='me-2'/>: <Icon.PlusCircle className='me-2 icon'/>}Other</Accordion.Header>
        <Accordion.Body>
          <Nav variant="pills" defaultActiveKey="/menu Items" className="d-flex flex-column">
            <Nav.Item>
                <Nav.Link onClick={ () => {navigate("/admin")}}  eventKey="/admin">
                  <Icon.Activity className="me-3"/>Menu 1</Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link onClick={ () => {navigate("/")}} eventKey="/">
                   <div><Icon.Calendar2Week className="me-3"/></div><div>Menu 2</div></Nav.Link>
            </Nav.Item>
           </Nav>
     </Accordion.Body>
     </Accordion.Item> */
}
